

import labDetailsReducer from './LabDetailsReducer'
export { labDetailsReducer }

export * from './LabDetailsActions'



// WEBPACK FOOTER //
// ./src/store/lab-details/index.js